import React, { useRef, useEffect } from 'react'
import './index.less'

interface ProgressBarProps {
	duration: number
	position: number
	style?: { [key: string]: string }
}

const ProgressBar = ({ duration, position, style }: ProgressBarProps) => {
	const progressBarRef = useRef<HTMLDivElement>(null)

	useEffect(() => {
		const el = progressBarRef.current
		if (el) {
			window.requestAnimationFrame(() => {
				// We set these values asynchronously so that the browser can recognize the change in the 'right' value.
				// Without this, the progress bar would instantly snap to the designated position.
				el.style.transition = `right ${duration}s linear`
				el.style.right = `${Math.max(0, 100 - position)}%`
			})
		}
	}, [duration, position])

	return (
		<div className="progress-bar_container" style={{ ...style }}>
			<div className="progress-bar_progress" ref={progressBarRef} data-testid="progressBar" />
			<div className="progress-bar_background" />
		</div>
	)
}

export default ProgressBar
